import { Component, ChangeDetectionStrategy } from '@angular/core';

import { GridModule, FormModule } from '@coreui/angular';

@Component({
  standalone: true,
  imports: [GridModule, FormModule],
  selector: 'app-page404',
  templateUrl: './page404.component.html',
  styleUrls: ['./page404.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Page404Component {
  constructor() {}
}
